import { render } from "./TabularDatasetImport.vue?vue&type=template&id=676e50e1&scoped=true"
import script from "./TabularDatasetImport.vue?vue&type=script&lang=js"
export * from "./TabularDatasetImport.vue?vue&type=script&lang=js"

import "./TabularDatasetImport.vue?vue&type=style&index=0&id=676e50e1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-676e50e1"]])

export default __exports__